// extracted by mini-css-extract-plugin
module.exports = {"section":"I_section__2t2E_"};